import { render, staticRenderFns } from "./MyCourseInfo.vue?vue&type=template&id=695a3cb3&"
import script from "./MyCourseInfo.vue?vue&type=script&lang=js&"
export * from "./MyCourseInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports